/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('@utils/account/accountModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const swiftypeModule = require('@utils/swiftype/swiftypeModule');
const IndexService = require('./indexService');

const indexModule = angular
    .module('enervee_utils.index', [
        accountModule.name,
        commonModule.name,
        consumersModule.name,
        cmsModule.name,
        swiftypeModule.name,
    ])
    .factory('IndexService', IndexService);

module.exports = indexModule;